import React from 'react';

const Warning = () => (
  <>
    <h2>High volume can cause hearing loss</h2>
    <p>
      Listening at a high volume for a long time may damage your hearing. Use
      with caution.
    </p>
    <p>A high volume may also damage your speakers.</p>
  </>
);

export default Warning;
